import { useState, useEffect } from 'react';
import { loadLetterImage } from '../utils/imageLoader.js';
import './LetterTile.css';

const LetterTile = ({
  letter,
  className = '',
  draggable = true,
  onClick,
  onDragStart,
  onDrag,
  onDragEnd,
  onTouchStart,
  onDoubleClick,
  style = {},
  isHintRevealed = false
}) => {
  const [letterImageUrl, setLetterImageUrl] = useState(null);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    const loadImages = async () => {
      try {
        const letterImg = await loadLetterImage(letter);

        setLetterImageUrl(letterImg);
        setImagesLoaded(true);
      } catch (error) {
        console.warn(`Failed to load images for letter ${letter}:`, error);
        setImagesLoaded(true);
      }
    };

    loadImages();
  }, [letter]);

  if (!imagesLoaded) {
    // Show loading state or fallback immediately
    return (
      <div
        className={`letter-tile-graphic ${className} loading`}
        draggable={draggable}
        onClick={onClick}
        onDragStart={onDragStart}
        onDrag={onDrag}
        onDragEnd={onDragEnd}
        onTouchStart={onTouchStart}
        onDoubleClick={onDoubleClick}
        style={style}
      >
        <div className="letter-image-container">
          <div className="letter-fallback">
            {letter}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`letter-tile-graphic ${className} ${isHintRevealed ? 'hint-revealed' : ''}`}
      draggable={draggable}
      onClick={onClick}
      onDragStart={onDragStart}
      onDrag={onDrag}
      onDragEnd={onDragEnd}
      onTouchStart={onTouchStart}
      onDoubleClick={onDoubleClick}
      style={style}
      data-letter={letter}
      title={`Letter: ${letter} (ASCII: ${letter.charCodeAt(0)})`}
    >
      <div className="letter-image-container">
        {letterImageUrl ? (
          <img
            src={letterImageUrl}
            alt={letter}
            className="letter-image"
            draggable={false}
            style={isHintRevealed ? { filter: 'hue-rotate(100deg) saturate(3) brightness(1.3) drop-shadow(0 0 3px #00ff00)' } : {}}
          />
        ) : (
          <div className="letter-fallback" style={isHintRevealed ? { color: '#00ff00', textShadow: '0 0 5px #00ff00' } : {}}>
            {letter}
          </div>
        )}
      </div>
      {isHintRevealed && <div className="hint-glow" />}
    </div>
  );
};

export default LetterTile;
